import React from 'react';

import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import TextField from '@material-ui/core/TextField';

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          preventDefault: () => {},
          target: {
            name: props.name,
            value: parseFloat(values.value),
          },
        });
      }}
      maxLength={10}
      thousandSeparator={'.'}
      decimalSeparator={','}
      isNumericString={true}
      prefix="B$ "
    />
  );
}

export default function TextFieldMoney({ children, ...props }) {
  return (<TextField {...props} InputProps={{ inputComponent: NumberFormatCustom }}>{children}</TextField>);
}
